export default __webpack_public_path__ + "static/media/308.4c0be408.png";